import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { usd } from './HeadlineStrip';

const LABELS = {
  voice: { label: 'Voice minutes & numbers', cls: 'bg-violet-500' },
  ai_reasoning: { label: 'AI reasoning (LLM)', cls: 'bg-emerald-500' },
  whatsapp: { label: 'WhatsApp', cls: 'bg-teal-500' },
  email: { label: 'Email sends', cls: 'bg-sky-500' },
  linkedin: { label: 'LinkedIn actions', cls: 'bg-blue-600' },
  data: { label: 'Contact data reveals', cls: 'bg-amber-500' },
};

export function SpendBreakdown({ report }) {
  const { leo } = report;
  const entries = Object.entries(leo.spend_by_bucket || {}).sort((a, b) => b[1] - a[1]);
  const total = entries.reduce((s, [, v]) => s + v, 0) || 1;
  return (
    <Card className="h-full" data-testid="leo-impact-spend">
      <CardHeader className="pb-3">
        <CardTitle className="text-base md:text-lg">Where LEO's {usd(leo.cost_usd, 2)} went</CardTitle>
        <p className="text-xs text-muted-foreground">From the credit ledger · {usd(leo.usage_usd, 2)} usage{leo.platform_fee_usd ? ` + ${usd(leo.platform_fee_usd, 2)} platform fee` : ''}{leo.refunds_usd ? ` · ${usd(leo.refunds_usd, 2)} refunded` : ''}</p>
      </CardHeader>
      <CardContent className="space-y-3">
        {entries.length === 0 && <p className="text-sm text-muted-foreground" data-testid="leo-impact-spend-empty">No AI usage charges in this period.</p>}
        <div className="flex h-3 w-full overflow-hidden rounded-full bg-muted">
          {entries.map(([k, v]) => (
            <div key={k} className={`${(LABELS[k] || LABELS.ai_reasoning).cls}`} style={{ width: `${(v / total) * 100}%` }} title={`${(LABELS[k] || {}).label || k}: ${usd(v, 2)}`} />
          ))}
        </div>
        <ul className="space-y-2">
          {entries.map(([k, v]) => (
            <li key={k} className="flex items-center justify-between text-sm" data-testid={`leo-impact-spend-${k}`}>
              <span className="flex items-center gap-2"><span className={`h-2.5 w-2.5 rounded-full ${(LABELS[k] || LABELS.ai_reasoning).cls}`} />{(LABELS[k] || {}).label || k}</span>
              <span className="tabular-nums font-medium">{usd(v, 2)} <span className="text-muted-foreground text-xs">({Math.round((v / total) * 100)}%)</span></span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
